import { TransactionDetails, TransactionRejectResponse } from 'models';
import { httpService } from 'services/httpService';

class TransactionService {
  resolveRejectionOtc(oneTimeCode: string) {
    return httpService.post<{ oneTimeCode: string }, TransactionDetails>(
      '/Transaction/ResolveCode',
      { oneTimeCode }
    );
  }

  rejectTransaction(transactionId: string, oneTimeCode: string) {
    return httpService.post<{ transactionId: string; oneTimeCode: string }, TransactionRejectResponse>(
      '/Transaction/Reject',
      { transactionId, oneTimeCode }
    );
  }
}

export const transactionService = new TransactionService();
